import axios from 'axios'
import { Constants } from '@/cfg/constants'
import { version } from '/package.json'
import { browserName } from '@basitcodeenv/vue3-device-detect'
import store from '@/store'

const api = axios.create({
    baseURL: Constants.API_URL_V2,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [
        (data) => {
            if (!data || typeof data !== 'object') return data

            const formData = new URLSearchParams()

            for (const key in data) {
                if (Object.hasOwn(data, key)) {
                    formData.append(key, data[key])
                }
            }
            formData.append('app_version', version)
            formData.append('os', 'web')

            const br = browserName()
            if (br) formData.append('device', br)

            return formData;
    }, ...axios.defaults.transformRequest]
 })

// -----------------------
// AUTH TOKEN INTERCEPTOR
// -----------------------
api.interceptors.request.use(async (config) => {
    try {
        // userMe may pass token explicitly during bootstrap.
        if (config.url && config.url.includes('/user/me')) {
            return config
        }

        const storeToken = store?.state?.auth?.token
        if (storeToken) {
            config.headers = config.headers || {}
            config.headers.Authorization = `Bearer ${storeToken}`
        }
    } catch (error) {
        console.warn('Failed to get auth token for API request:', error)
    }
    
    return config;
})

export default api
